import React, {FC, PropsWithChildren, useMemo} from 'react';

import {buildInteractionIdProps} from '../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {useUniqueElementId} from '../../../../libs/shared/helpers/src/react/hooks/uniqueIdHelpers';
import {ModalContext, ModalContextValue} from './modalContext';

/*
 * Props.
 */

export interface ModalProps {
  className?: string;
  interactionId?: string;
}

/*
 * Component.
 */

export const Modal: FC<PropsWithChildren<ModalProps>> = ({className, children, interactionId}) => {
  const labelId = useUniqueElementId();
  const context = useMemo<ModalContextValue>(
    () => ({
      getLabelProps: () => ({
        id: labelId,
      }),
    }),
    [labelId],
  );

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={labelId}
      className={className}
      {...buildInteractionIdProps(interactionId)}
    >
      <ModalContext.Provider value={context}>{children}</ModalContext.Provider>
    </div>
  );
};
